module.exports = __webpack_public_path__ + "img/kbank.a7df2a86.png";